import React from 'react';

import { gql } from '@apollo/client';
 
import { MusicNote } from '@mui/icons-material';

import { useQuery } from '@apollo/client'

import { CircularProgress, Typography } from '@mui/material';

import { NodeTable } from '@/components/NodeTable';

import i18n from '@/i18n';

import { Link } from '@/components';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { removeNull } from '@/utils';

const QUERY = gql`
  query getArtificialStreamsTrackReport($reportId: ID!, $sortBy: String, $entity: String, $parentNodeType: String, $parentNodeId: ID) {
    spotify {
      artificialStreamsTrackReport(reportId: $reportId) {
        id
        start
        end
        topOffendingEntities(
          entity: $entity,
          parentNodeType: $parentNodeType,
          parentNodeId: $parentNodeId,
          sortBy: $sortBy
        ) {
          id
          name
          type
          quantity
          penalty
        }
      }
    }
  }
`


export function ArtificialStreamingTracksReportPage() {
  const { reportId, entity, parentNodeType, parentNodeId } = useParams()

  return ( 
    <ArtificialStreamingTracksReportContainer
      reportId={reportId}
      entity={entity}
      parentNodeType={parentNodeType}
      parentNodeId={parentNodeId}
    /> 
  )
} 

export function ArtificialStreamingTracksReportContainer({
  reportId, entity = "label_name", parentNodeId, parentNodeType
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const sortBy = removeNull(searchParams.get('sortBy')) ?? null

  const { data, loading, previousData } = useQuery(QUERY, {
    variables: {
      entity,
      reportId,
      parentNodeId,
      sortBy,
      parentNodeType
    }
  })

  const handleSortByChanged = ({ sortByFieldId, sortByDirection }) => {
    let sortBy = ''
    if (sortByDirection == 'desc') {
      sortBy += '-'
    }
    if (sortByFieldId?.length > 0) {
      sortBy += sortByFieldId
    } else {
      sortBy = null
    }
    setSearchParams(params => {
      if (sortBy) {
        params.set('sortBy', sortBy)
      } else {
        params.delete('sortBy')
      }
      return params
    })
  }

  const onNodesChecked = () => {}
  const onPerformAction = () => {}

  if (loading && !previousData) {
    return <CircularProgress />
  }

  if ((data ?? previousData)?.spotify?.artificialStreamsTrackReport) {
    const spotify = (data ?? previousData)?.spotify
    const report = spotify?.artificialStreamsTrackReport
    const rows = report.topOffendingEntities

    return (
      <>
        <Typography level="h1">Top {entity} in artificial streams report in {parentNodeId} {parentNodeType} for {report.start} - {report.end}</Typography>
        <NodeTable
          sortLocal={true}
          defaultSortByFieldId={sortBy?.replace(/-/, '')}
          defaultSortByDirection={sortBy?.startsWith('-') ? 'desc' : 'asc'}
          onSortByChanged={handleSortByChanged}
          onNodesChecked={onNodesChecked}
          onPerformAction={onPerformAction}
          canCheck={true}  
          renderRowClassNames={({ node }) => {    
            return !node.uncopyrighted || !node.notMatchesArtistWatchlist || !node.originalReleaseDateMatchesCopyrightYears || !node.originalReleaseDateIsNotDifferentFromCopyrightAndPhonographicYear ? 'row-warning' : ''
          }}
          emptyHeading={i18n.t('Report not found')}
          emptyText={i18n.t('Report not found')}
          emptyIcon={MusicNote}
    
          isRowUnavailable={(row) => {
            return false        
          }}
          toolbarButtons={() => <></>}
          sx={{
            '& .row-success': {
              bgcolor: 'rgba(0, 255, 0, .1)'
            },
            '& .row-error': {
              bgcolor: 'rgba(255, 0, 0, .1)'
            },
            '& .row-warning': {
              bgcolor: 'rgba(255, 255, 0, .1)'
            }
          }}
          actions={[ 
          ]}
          columns={[
            {
              id: 'name',
              name: i18n.t('name'),
              type: 'name',
              sortable: true,
              render: ({ node }) => {
                return (
                  <Link to={`/dashboard/screening/artificial-streaming/report/${reportId}/${node.type}/${encodeURIComponent(node.id)}/track_name`}>{node.name}</Link>
                )
              }
            },
            {
              id: 'penalty',
              name: i18n.t('penalty'),
              type: 'currency',
              sortable: true,
              render: ({ node, column }) => {
                return (
                  <span style={{ textAlign: 'right' }}>
                    <Typography textAlign="right">{(node[column.id] ?? 0)?.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</Typography>
                  </span>
                )
              } 
            }, 
            {
              id: 'view',
              sortable: true,
              name: i18n.t('quantity'),
              type: 'text',
              render: ({ node }) => { 
                return (
                  <Typography textAlign="right">{node.quantity?.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</Typography>
                )
              }
            }
          ]}
          nodes={rows}
        />
      </>
    )
  } else {
    return (
      <p>Error</p>
    )
  }
}

export default ArtificialStreamingTracksReportPage;
